module.exports = __webpack_public_path__ + "img/今日头条_04.c59505ab.jpg";